import { Pagination } from "react-admin"

export const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[25, 50, 100]} {...props} />
)

export const PostPagination50 = (props) => (
  <Pagination rowsPerPageOptions={[50, 100, 250]} {...props} />
)
